'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var Modal = (_temp = _class = function (_U$BaseComponent) {
  _inherits(Modal, _U$BaseComponent);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Modal).call(this, props));

    Object.assign(_this.state, {
      items: []
    });
    return _this;
  }

  _createClass(Modal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var items = this.state.items;

      var prefixCls = this.props.prefixCls + '-modal';
      return _react2.default.createElement(
        'div',
        { className: this.classNames('' + prefixCls), hidden: items.length === 0 },
        items.map(function (item) {
          return _react2.default.createElement(
            'div',
            {
              key: item.id,
              className: prefixCls + '_mask',
              onClick: _this2.handleMaskClick.bind(_this2, item)
            },
            _react2.default.createElement(item.ModalContent, { onClose: _this2.remove.bind(_this2, item) })
          );
        })
      );
    }
  }, {
    key: 'handleMaskClick',
    value: function handleMaskClick(item, e) {
      if (item.onMaskClick != null && e.target === e.currentTarget) {
        item.onMaskClick(this.remove.bind(this, item));
      }
    }
  }, {
    key: 'append',
    value: function append(ModalContent) {
      var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

      var onClose = _ref.onClose;
      var onMaskClick = _ref.onMaskClick;

      var id = modalId++;
      var resolve = null;
      var promise = new Promise(function (r) {
        return resolve = r;
      });
      this.state.items.push({ id: id, ModalContent: ModalContent, onClose: onClose, onMaskClick: onMaskClick, resolve: resolve });
      this.forceUpdate();
      promise.close = this.remove.bind(this, id);
      return promise;
    }
  }, {
    key: 'remove',
    value: function remove(item, data) {
      var _this3 = this;

      (item.onClose || call)(function () {
        var items = _this3.state.items;

        var index = items.findIndex(function (x) {
          return x.id === item.id || x.id === item;
        });
        if (index !== -1) {
          items.splice(index, 1)[0].resolve(data);
          _this3.forceUpdate();
        }
      }, data);
    }
  }], [{
    key: 'getContainer',
    value: function getContainer() {
      return document.body;
    }
  }, {
    key: 'show',
    value: function show(ModalContent, config) {
      if (this.instance == null) {
        var $container = document.createElement('div');
        this.getContainer().appendChild($container);
        this.instance = _reactDom2.default.render(_react2.default.createElement(Modal, { prefixCls: this.prefixCls }), $container);
      }
      return this.instance.append(ModalContent, config);
    }
  }, {
    key: 'clear',
    value: function clear() {
      if (this.instance == null) return;
      return this.instance.setStateAsync({ items: [] });
    }
  }]);

  return Modal;
}(_util2.default.BaseComponent), _class.defaultProps = {
  prefixCls: 'mt'
}, _class.prefixCls = undefined, _temp);


var modalId = 0;

var call = function call(x) {
  return x();
};

exports.default = Modal;